import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistActiveItemsReducer } from 'features/Persist/reducerTypes';
import { TicketAssignedGroupResponse } from 'services/tenantManagementService';
import { TICKET_ASSIGNED_GROUP_SET, TICKET_ASSIGNED_GROUP_FETCHING } from './action';

export const ticketAssignedGroupsReducer = (state = new PersistActiveItemsReducer<TicketAssignedGroupResponse>(), action: PersistItemsActionType<TicketAssignedGroupResponse > | FetchingActionType): PersistActiveItemsReducer<TicketAssignedGroupResponse > => {
	switch (action.type) {
		case TICKET_ASSIGNED_GROUP_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case TICKET_ASSIGNED_GROUP_SET:
			const { items } = action as PersistItemsActionType<TicketAssignedGroupResponse >;

			const itemsMap: { [id: number]: TicketAssignedGroupResponse  } = items.reduce(
                (map: { [id: number]: TicketAssignedGroupResponse  }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			const activeItems = items.filter(x => x.isActive);

			const activeItemsMap: { [id: number]: TicketAssignedGroupResponse } = items.reduce(
                (map: { [id: number]: TicketAssignedGroupResponse }, item) => {
					if (item.isActive) {
						map[item.id] = item;
					}
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				activeItems,
				activeItemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
